import type { ReactNode } from 'react'
import cn from 'classnames'

import { Typography } from '@/UI-KIT/Typography/Typography'

import styles from './SectionHeader.module.scss'

type SectionHeaderProps = {
  kicker: string
  title: ReactNode
  lede?: ReactNode
  id?: string
  /** The problem section names itself in red; everything else keeps the accent. */
  kickerTone?: 'accent' | 'bad'
}

/** kicker → heading → lede, in the same three sizes on all sections of the page. */
export const SectionHeader = ({ kicker, title, lede, id, kickerTone = 'accent' }: SectionHeaderProps) => (
  <header className={styles.root}>
    <div className={cn(styles.kicker, { [styles.kickerBad as string]: kickerTone === 'bad' })}>
      {kicker}
    </div>
    <Typography variant="h2" color="heading" id={id} className={styles.title}>
      {title}
    </Typography>
    {lede ? (
      <Typography variant="t2" color="body" className={styles.lede}>
        {lede}
      </Typography>
    ) : null}
  </header>
)
